<template>
  <div id="address_page">
    <div class="d-flex align-items-center px-3 mb-4">
      <div>
        <span class="h4">آدرس</span>
      </div>
    </div>
    <form @submit.prevent="submitForm" class="px-3">
      <div class="form-group">
        <label for="add_address_modal_code" class="col-form-label"
        >کد پستی</label
        >
        <input
            type="text"
            class="form-control"
            dir="ltr"
            id="add_address_modal_code"
            name="new_postal_code"
            v-model="new_postal_code"
        />
      </div>
      <div class="form-group">
        <label for="add_address_modal_address" class="col-form-label"
        >آدرس پستی</label
        >
        <textarea
            class="form-control"
            id="add_address_modal_address"
            name="new_address"
            v-model="new_address"
        ></textarea>
      </div>
      <div class="d-flex align-items-center px-3 mt-5">
        <div>
          <button
              type="button"
              class="btn btn-success px-4"
              style="border-radius: 10px"
              @click="--wizard.current_step"
          >
            مرحله قبل
          </button>
        </div>
        <div class="mr-auto">
          <button
              type="submit"
              class="btn btn-success px-4"
              style="border-radius: 10px"
              id="submit_btn"
              :disabled="form_submit_loading"
          >
            <span v-if="form_submit_loading">
              <span class="pl-2">در حال انجام</span>
              <span
                  class="spinner-border spinner-border-sm p-2"
                  role="status"
              ></span>
            </span>
            <span v-else>مرحله بعد</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { addressService } from "@/common/api.service";
import $ from "jquery";
import Inputmask from "inputmask";

export default {
  name: "addresses",
  props: {
    wizard: Object,
  },
  computed: {
    ...mapGetters("address", ["addresses"]),
  },
  mounted() {
    this.$store.dispatch("address/fetch").then(() => {
      let postal_code = this.addresses[0].postal_code;
      let address = this.addresses[0].address;

      if (postal_code != null && postal_code != undefined) {
        this.new_postal_code = postal_code;
      }

      if (address != null && address != undefined) {
        this.new_address = address;
      }
    });
    this.$nextTick(function () {
      setTimeout(() => {
        Inputmask("99999-99999").mask(
            document.querySelectorAll("#add_address_modal_code")
        );
      }, 1000);
    });
  },
  data() {
    return {
      new_address: "",
      new_postal_code: "",
      form_submit_loading: false,
    };
  },
  methods: {
    submitForm(e) {
      let form = $(e.target);

      form.validate({
        rules: {
          new_address: {
            required: true,
          },
          new_postal_code: {
            required: true,
          }
        },
      });

      if (!form.valid()) {
        form.off(".validate").removeData("validator");
        return;
      }

      let params = [];

      params.push({
        id: 0,
        address: this.new_address,
        postal_code: this.new_postal_code,
      });

      this.new_address = "";
      this.new_postal_code = "";
      this.submitHelper(params);
    },
    submitHelper(params) {
      let el = $("#address_page");
      this.form_submit_loading = true;
      addressService
          .sync({ addresses: params })
          .then((response) => {
            this.wizard.current_step = 4;
          })
          .catch(({ response }) => {
            this.showMsg(el, "danger", response.data.message);
          })
          .finally(() => {
            this.form_submit_loading = false;
          });
    },
  },
};
</script>

<style scoped>
</style>
